/**
 * @param {*} date
 * @returns {date is Date}
 */
function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}

export { isValidDate };
